import React, { type FC, useId } from 'react';

import { cn } from '@/lib/utils';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

interface StarProps extends InputProps {
  starValue: string;
  checkedClassName?: string;
  unCheckedClassName?: string;
}

const Star: FC<StarProps> = ({
  starValue,
  value,
  id: propsId,
  className,
  readOnly,
  disabled,
  checkedClassName,
  unCheckedClassName,
  onChange,
  ...props
}) => {
  const generatedId = useId();
  const id = propsId || generatedId;
  const checked = Number(value) >= Number(starValue);

  return (
    <label
      className={cn(
        'text-gray-300',
        !(disabled || readOnly) && 'cursor-pointer hover:text-primary-light',
        checked && 'text-primary-light',
        checked && checkedClassName,
        !checked && unCheckedClassName,
        className
      )}
      htmlFor={id}
    >
      &#9733;
      <input
        className="peer hidden"
        type="radio"
        id={id}
        disabled={disabled}
        value={starValue}
        defaultChecked={checked}
        // @ts-expect-error: weird event type issue
        onClick={onChange}
        readOnly
        {...props}
      />
    </label>
  );
};

interface StarsInputProps extends InputProps {
  starsCount?: number;
}

export const StarsInput: FC<StarsInputProps> = React.forwardRef<
  HTMLFieldSetElement,
  StarsInputProps
>(({ starsCount = 5, ...props }, ref) => (
  <fieldset ref={ref} className="flex w-20 flex-row-reverse justify-around px-1 text-3xl">
    {Array.from({ length: starsCount }).map((_, i) => (
      <Star
        key={`starsCount#${String.fromCharCode(65 + i)}`}
        starValue={(starsCount - i).toString()}
        {...props}
      />
    ))}
  </fieldset>
));
